// extracted by mini-css-extract-plugin
export default {"toolBar":"styles_toolBar__wXeyd","zoomIcon":"styles_zoomIcon__G-J0O","toolBarButton":"styles_toolBarButton__0gGa2","mr5":"styles_mr5__6pZCg"};